/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared';
import { ProfileFormComponent } from './profile-form/profile-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ProfileFormService } from '@app/profile/profile-form.service';
import { ProfileService } from '@app/profile/profile.service';

@NgModule({
  declarations: [ProfileFormComponent],
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
  providers: [ProfileService, ProfileFormService],
})
export class ProfileModule {}
